import { Button, Flex, Space, Tag, Typography } from 'antd';

import type { NotificationList } from '../../shared/api-client.js';
import { businessCodeDisplay } from '../../shared/business-code-display.js';
import { formatShanghaiDateTime } from '../../shared/business-date.js';

import { exportNotificationMessage } from './export-failure-display.js';

export type ExportNotification = NotificationList['items'][number];

interface ExportNotificationListProps {
  readonly downloadPendingId?: string | undefined;
  readonly items: readonly ExportNotification[];
  readonly limit?: number;
  readonly markReadPendingId?: string | undefined;
  readonly retryPendingId?: string | undefined;
  readonly onDownload: (item: ExportNotification) => void;
  readonly onMarkRead: (item: ExportNotification) => void;
  readonly onRetry: (item: ExportNotification) => void;
}

export function ExportNotificationList({
  downloadPendingId,
  items,
  limit = items.length,
  markReadPendingId,
  onDownload,
  onMarkRead,
  onRetry,
  retryPendingId,
}: ExportNotificationListProps) {
  return (
    <ul className="task-feed" aria-label="导出通知">
      {items.slice(0, limit).map((item) => {
        const notification = businessCodeDisplay('notificationType', item.notificationType);
        return (
          <li key={item.id} className="task-feed-item">
            <Flex align="flex-start" gap="middle" justify="space-between" wrap>
              <Space orientation="vertical" size={3}>
                <Space size="small" wrap>
                  <Typography.Text strong={!item.isRead}>{item.title}</Typography.Text>
                  <Tag color={notification.color}>{notification.label}</Tag>
                  {!item.isRead ? <Tag color="blue">未读</Tag> : null}
                </Space>
                <Typography.Text type="secondary">
                  {exportNotificationMessage(item)}
                </Typography.Text>
                <Typography.Text type="secondary">{formatDateTime(item.createdAt)}</Typography.Text>
              </Space>
              <Space size={4}>
                {item.notificationType === 'EXPORT_SUCCESS' && notification.known ? (
                  <Button
                    loading={downloadPendingId === item.exportTaskId}
                    type="link"
                    onClick={() => {
                      onDownload(item);
                    }}
                  >
                    下载
                  </Button>
                ) : null}
                {item.notificationType === 'EXPORT_FAILED' && notification.known ? (
                  <Button
                    loading={retryPendingId === item.exportTaskId}
                    type="link"
                    onClick={() => {
                      onRetry(item);
                    }}
                  >
                    重试
                  </Button>
                ) : null}
                {!item.isRead ? (
                  <Button
                    loading={markReadPendingId === item.id}
                    type="link"
                    onClick={() => {
                      onMarkRead(item);
                    }}
                  >
                    标为已读
                  </Button>
                ) : null}
              </Space>
            </Flex>
          </li>
        );
      })}
    </ul>
  );
}

function formatDateTime(value: string) {
  return formatShanghaiDateTime(value);
}
